.wordmark {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1-5);
  color: var(--color-fg);
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
  letter-spacing: -0.01em;
}

.glyph {
  width: 0.95em;
  height: 0.95em;
  color: var(--color-accent);
}
